export default function AdminHeader({ title, subtitle, actions, breadcrumb, testId = "admin-header" }) {
  return (
    <div className="border-b border-altura-espresso/10 bg-white px-8 py-6" data-testid={testId}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="space-y-1.5">
          {breadcrumb && <div className="text-[11px] uppercase tracking-[0.2em] text-altura-espresso/50">{breadcrumb}</div>}
          <h1 className="font-editorial text-3xl leading-none text-altura-espresso">{title}</h1>
          {subtitle && <p className="text-sm text-altura-charcoal/70 max-w-2xl">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
